import { useState } from "react"
import { useEffect } from "react"
import Send from "../../core/communication"
import { customToast } from "../../components/Toast"
import { useScope } from "../SelectProjectCompanyContainer"
import CodesValuesScreenFixed from "../../screen/CodesValuesScreenFixed"

const CodesValuesContainerFixed = ({
  esmId,
  setValues,
  setResponseCodesSearch,
  values,
  isSearch,
  setIsSearch,
  setLoadingSearch,
  loadingSearch,
  resetFields,
  setResetFields,
  isProcessingUser = false,
}) => {
  const { projectsByScope } = useScope()
  const [codesValues, setCodesValues] = useState([])
  const [codesSelect, setCodesSelect] = useState([])

  const commonItens = [
    {
      id: "b6d233aa-9bc9-4864-822c-3afbcaaa9eab",
      name: "Etnia",
      type: "select",
      isMulti: "false",
    },
    {
      name: "Comunidade",
      code: "COMUNIDADE",
    },
    {
      name: "Associação / Território",
      code: "ASSOCIACAOTERRITORIO",
    },
  ]

  const filterByQuestionId =
    isProcessingUser || esmId === "7ea1de77-706a-413f-a9da-cb6f82febcbc"
      ? []
      : esmId === "a0fb8927-15fa-4687-aeed-2178609446cb"
      ? [
          {
            id: "80d1dbe5-9a0d-4f58-aad8-a53dea2ec98f",
            name: "Gênero",
            type: "select",
            isMulti: "false",
          },
          ...commonItens,
          {
            id: "d5afa28f-096a-4c9b-be32-fd6708aefa09",
            name: "Quais produtos produz/coleta/extrai ?",
            type: "select",
            isMulti: "true",
          },
        ]
      : [
          {
            id: "0631be10-3d1d-4af6-b7c5-90a7790faae7",
            name: "Gênero",
            type: "select",
            isMulti: "false",
          },
          ...commonItens,
        ]

  const filterQuestionsByCode =
    esmId === "a0fb8927-15fa-4687-aeed-2178609446cb"
      ? [
          {
            "b6d233aa-9bc9-4864-822c-3afbcaaa9eab": [
              { value: "Prefiro não responder", label: "Prefiro não responder" },
              { value: "Branca", label: "Branca" },
              { value: "Indígena", label: "Indígena" },
              { value: "Parda", label: "Parda" },
              { value: "Preta", label: "Preta" },
            ],
            "80d1dbe5-9a0d-4f58-aad8-a53dea2ec98f": [
              { value: "Prefiro não dizer", label: "Prefiro não dizer" },
              { value: "Feminino", label: "Feminino" },
              { value: "Masculino", label: "Masculino" },
              { value: "Outro", label: "Outro" },
            ],
            "d5afa28f-096a-4c9b-be32-fd6708aefa09": [
              { value: "Andiroba", label: "Andiroba" },
              { value: "Castanha-do-Pará", label: "Castanha-do-Pará" },
              { value: "Copaíba", label: "Copaíba" },
              { value: "Pimenta Assisí", label: "Pimenta Assisí" },
              { value: "Cumaru", label: "Cumaru" },
            ],
          },
        ]
      : [
          {
            "b6d233aa-9bc9-4864-822c-3afbcaaa9eab": [
              { value: "Prefiro não responder", label: "Prefiro não responder" },
              { value: "Branca", label: "Branca" },
              { value: "Indígena", label: "Indígena" },
              { value: "Parda", label: "Parda" },
              { value: "Preta", label: "Preta" },
            ],
            "0631be10-3d1d-4af6-b7c5-90a7790faae7": [
              { value: "Mulher", label: "Mulher" },
              { value: "Homem", label: "Homem" },
            ],
          },
        ]

  useEffect(() => {
    if (filterByQuestionId && filterByQuestionId.length && !codesValues.length) {
      setCodesValues([
        ...codesValues,
        ...filterByQuestionId.filter(
          (item) => !codesValues.map((code) => code?.id).includes(item.id),
        ),
      ])
    }
  }, [filterByQuestionId])

  const removeProperties = (originalArray, propertiesToRemove) => {
    return originalArray.map((obj) => {
      const newObj = { ...obj }
      for (const prop of propertiesToRemove) {
        delete newObj[prop]
      }
      return newObj
    })
  }

  useEffect(() => {
    if (isProcessingUser && codesValues.length > 0) {
      setValues(null)
      setCodesSelect(null)
    }
  }, [isProcessingUser])

  useEffect(() => {
    if (codesSelect && codesSelect.length) {
      setResetFields(false)
    }
  }, [codesSelect])

  const searchEsm = async () => {
    try {
      setLoadingSearch(true)
      let response = []
      const filteredCodeValues = removeProperties(codesValues, ["name", "id", "type", "isMulti"])
      const groupedCodes = groupSelectByCode(codesSelect)
      const mergedArr = [...filteredCodeValues, ...groupedCodes]

      const checkCodeSelect = mergedArr.some((cd) => cd?.value !== "" || cd?.values?.length > 0)
        ? mergedArr
        : []

      if (checkCodeSelect.length) {
        response = await Send.post("/ia/producersByCode", {
          code: checkCodeSelect,
          projects: projectsByScope
            .map((item) => item.id)
            .map((item) => `'${item}'`)
            .join(","),
        })
      }

      if (response && Array.isArray(response)) {
        setValues(mergedArr)
        setResponseCodesSearch({
          data: response,
        })

        customToast("Dados filtrados!", "success")
      } else {
        throw new Error(response)
      }
    } catch (error) {
      console.error(error)
    }
    setIsSearch(false)
    setLoadingSearch(false)
  }

  useEffect(() => {
    if (isSearch && codesValues.length > 0) {
      searchEsm()
    }
  }, [isSearch, codesValues])

  const groupSelectByCode = (codeSelect) => {
    return Object.values(
      codeSelect.reduce((result, currentItem) => {
        const id = currentItem.code

        if (!result[id]) {
          result[id] = { id, values: [] }
        }

        result[id].values.push(currentItem.value)

        return result
      }, {}),
    )
  }

  const handleChangeCodes = (data, e, id) => {
    if (e && e?.action) {
      if (e.action === "select-option") {
        const values = data.map(({ value, label }) => ({ code: id, value, label }))
        const newCodesValues = [
          ...codesSelect,
          ...values.filter(
            (item) => !codesSelect.some((i) => i.value == item.value && i.code == item.code),
          ),
        ]
        setCodesSelect(newCodesValues)
        setValues(newCodesValues)
      } else {
        const newCodesValues = codesSelect.filter((item) => item.value !== e?.removedValue?.value)
        setCodesSelect(newCodesValues)
        setValues(newCodesValues)
      }
    } else {
      const newCodesValues = [...codesValues]
      newCodesValues[data][e.target.name] = e.target.value
      setCodesValues(newCodesValues)
      setValues(!isSearch && newCodesValues)
    }
  }

  return (
    <CodesValuesScreenFixed
      {...{
        esmId,
        codesValues,
        values,
        codesSelect,
        resetFields: resetFields || isProcessingUser,
        isProcessingUser,
        handleChangeCodes,
        loadingSearch,
        filterQuestionsByCode,
      }}
    />
  )
}

export default CodesValuesContainerFixed
